import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {environment} from 'src/environments/environment';
import {QuickLink, QuickLinkCategory, QuickLinkCategoryInput, QuickLinkInput} from './quick-link.model';

@Injectable({providedIn: 'root'})
export class QuickLinkService {
  private readonly linkUrl = environment.endPoint + ApplicationPackage.AUTH_OP + 'quicklinks';
  private readonly categoryUrl = environment.endPoint + ApplicationPackage.AUTH_OP + 'quicklinkcategories';

  constructor(private http: HttpClient) {}

  getLinks(): Observable<QuickLink[]> {
    return this.http.get<QuickLink[]>(this.linkUrl);
  }

  getPublicLinks(): Observable<QuickLink[]> {
    return this.http.get<QuickLink[]>(this.linkUrl + '/public');
  }

  createLink(input: QuickLinkInput): Observable<QuickLink> {
    return this.http.post<QuickLink>(this.linkUrl, input);
  }

  updateLink(id: number, input: QuickLinkInput): Observable<QuickLink> {
    return this.http.put<QuickLink>(this.linkUrl + '/' + id, input);
  }

  deleteLink(id: number): Observable<void> {
    return this.http.delete<void>(this.linkUrl + '/' + id);
  }

  getCategories(): Observable<QuickLinkCategory[]> {
    return this.http.get<QuickLinkCategory[]>(this.categoryUrl);
  }

  createCategory(input: QuickLinkCategoryInput): Observable<QuickLinkCategory> {
    return this.http.post<QuickLinkCategory>(this.categoryUrl, input);
  }

  updateCategory(id: number, input: QuickLinkCategoryInput): Observable<QuickLinkCategory> {
    return this.http.put<QuickLinkCategory>(this.categoryUrl + '/' + id, input);
  }

  reorderCategories(categoryIds: number[]): Observable<QuickLinkCategory[]> {
    return this.http.put<QuickLinkCategory[]>(this.categoryUrl + '/order', {categoryIds: categoryIds});
  }

  deleteCategory(id: number): Observable<void> {
    return this.http.delete<void>(this.categoryUrl + '/' + id);
  }
}
